"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UI_COLOR_TRANSPARENT = exports.UI_COLOR_ROSE_FOG = exports.UI_COLOR_BOOL = exports.UI_COLOR_LIGHT_RED = exports.UI_COLOR_ROSE = exports.UI_COLOR_BURGUNDY = exports.UI_COLOR_MAJOR_DISRUPTION = exports.UI_COLOR_RED = exports.UI_COLOR_NUMBER = exports.UI_COLOR_UPCOMING = exports.UI_COLOR_STUDIO = exports.UI_COLOR_PURPLE_BLUE = exports.UI_COLOR_VANILLA = exports.UI_COLOR_DATE = exports.UI_COLOR_DATETIME = exports.UI_COLOR_BANANA_MANIA = exports.UI_COLOR_PICKLIST = exports.UI_COLOR_DURATION = exports.UI_COLOR_NEW_TIME = exports.UI_COLOR_MINOR_DISRUPTION = exports.UI_COLOR_YELLOW = exports.UI_COLOR_ORANGE = exports.UI_COLOR_OVERDUE = exports.UI_COLOR_POTTERS_CLAY = exports.UI_COLOR_FORMULA = exports.UI_COLOR_CONDITION = exports.UI_COLOR_COLUMN = exports.UI_COLOR_BRAND_GREEN = exports.UI_COLOR_LIGHT_GREEN = exports.UI_COLOR_BRIGHT_APPLE_GREEN = exports.UI_COLOR_APPLE_GREEN = exports.UI_COLOR_ON_TRACK = exports.UI_COLOR_GREEN = exports.UI_COLOR_OFF_GREEN_LIGHTER = exports.UI_COLOR_OFF_GREEN = exports.UI_COLOR_WHITE = exports.UI_COLOR_OFF_WHITE = exports.UI_COLOR_DARK_WHITE = exports.UI_COLOR_PALE_GRAY = exports.UI_COLOR_ALABASTER = exports.UI_COLOR_LIGHT_GRAY = exports.UI_COLOR_ATHENS_GRAY = exports.UI_COLOR_GALLERY = exports.UI_COLOR_GRAY_WHITE = exports.UI_COLOR_BORDER = exports.UI_COLOR_PLAIN_GRAY = exports.UI_COLOR_NOBEL = exports.UI_COLOR_SANTAS_GRAY = exports.UI_COLOR_STATUS_PENDING = exports.UI_COLOR_BRAND_GRAY = exports.UI_COLOR_MEDIUM_GRAY = exports.UI_COLOR_BOULDER = exports.UI_COLOR_DARKEN_BORDER = exports.UI_COLOR_GRAY = exports.UI_COLOR_TAB = exports.UI_COLOR_DEFAULT = exports.UI_COLOR_DISCONTINUED = exports.UI_COLOR_BLACK = exports.UI_COLOR_PAINT_GRAY = exports.UI_COLOR_PALE_BLUE = exports.UI_COLOR_STRING = exports.UI_COLOR_CORNFLOWER_BLUE = exports.UI_COLOR_VIKING_BLUE_DARKEN_12 = exports.UI_COLOR_VIKING_BLUE = exports.UI_COLOR_VARIABLE = exports.UI_COLOR_IN_PROGRESS = exports.UI_COLOR_LIGHT_BLUE = exports.UI_COLOR_PROGRESS_BAR = exports.UI_COLOR_COMPLETED = exports.UI_COLOR_DARK_BLUE = exports.UI_COLOR_BLUE = exports.UI_COLOR_BRAND_BLUE = exports.UI_COLOR_BRAND_PRIMARY_ALT = exports.UI_COLOR_NEW = exports.UI_COLOR_BRAND_PRIMARY = void 0;

/**
 * Do not edit directly
 * Generated on Wed, 31 Jan 2024 01:00:33 GMT
 */
var UI_COLOR_BRAND_PRIMARY = "#066a8d";
exports.UI_COLOR_BRAND_PRIMARY = UI_COLOR_BRAND_PRIMARY;
var UI_COLOR_NEW = "#027ea2"; // very rare

exports.UI_COLOR_NEW = UI_COLOR_NEW;
var UI_COLOR_BRAND_PRIMARY_ALT = "#007da5";
exports.UI_COLOR_BRAND_PRIMARY_ALT = UI_COLOR_BRAND_PRIMARY_ALT;
var UI_COLOR_BRAND_BLUE = "#007ca0";
exports.UI_COLOR_BRAND_BLUE = UI_COLOR_BRAND_BLUE;
var UI_COLOR_BLUE = "#007fa2"; // rare

exports.UI_COLOR_BLUE = UI_COLOR_BLUE;
var UI_COLOR_DARK_BLUE = "#0856af"; // rare

exports.UI_COLOR_DARK_BLUE = UI_COLOR_DARK_BLUE;
var UI_COLOR_COMPLETED = "#1565C0";
exports.UI_COLOR_COMPLETED = UI_COLOR_COMPLETED;
var UI_COLOR_PROGRESS_BAR = "#1594c9"; // rare

exports.UI_COLOR_PROGRESS_BAR = UI_COLOR_PROGRESS_BAR;
var UI_COLOR_LIGHT_BLUE = "#71ade4";
exports.UI_COLOR_LIGHT_BLUE = UI_COLOR_LIGHT_BLUE;
var UI_COLOR_IN_PROGRESS = "#64B5F6";
exports.UI_COLOR_IN_PROGRESS = UI_COLOR_IN_PROGRESS;
var UI_COLOR_VARIABLE = "#54b2ef"; // very rare

exports.UI_COLOR_VARIABLE = UI_COLOR_VARIABLE;
var UI_COLOR_VIKING_BLUE = "#51b6d4"; // very rare

exports.UI_COLOR_VIKING_BLUE = UI_COLOR_VIKING_BLUE;
var UI_COLOR_VIKING_BLUE_DARKEN_12 = "#34aacd"; // very rare

exports.UI_COLOR_VIKING_BLUE_DARKEN_12 = UI_COLOR_VIKING_BLUE_DARKEN_12;
var UI_COLOR_CORNFLOWER_BLUE = "#76bcd0";
exports.UI_COLOR_CORNFLOWER_BLUE = UI_COLOR_CORNFLOWER_BLUE;
var UI_COLOR_STRING = "#80e5ff"; // very rare

exports.UI_COLOR_STRING = UI_COLOR_STRING;
var UI_COLOR_PALE_BLUE = "#d3ebf3"; // very rare

exports.UI_COLOR_PALE_BLUE = UI_COLOR_PALE_BLUE;
var UI_COLOR_PAINT_GRAY = "#e0ebeb";
exports.UI_COLOR_PAINT_GRAY = UI_COLOR_PAINT_GRAY;
var UI_COLOR_BLACK = "#1b1b1b";
exports.UI_COLOR_BLACK = UI_COLOR_BLACK;
var UI_COLOR_DISCONTINUED = "#36312d";
exports.UI_COLOR_DISCONTINUED = UI_COLOR_DISCONTINUED;
var UI_COLOR_DEFAULT = "#404040"; // default color for text

exports.UI_COLOR_DEFAULT = UI_COLOR_DEFAULT;
var UI_COLOR_TAB = "#4b5253"; // rare

exports.UI_COLOR_TAB = UI_COLOR_TAB;
var UI_COLOR_GRAY = "#555555";
exports.UI_COLOR_GRAY = UI_COLOR_GRAY;
var UI_COLOR_DARKEN_BORDER = "#757575"; // very rare

exports.UI_COLOR_DARKEN_BORDER = UI_COLOR_DARKEN_BORDER;
var UI_COLOR_BOULDER = "#777777"; // rare

exports.UI_COLOR_BOULDER = UI_COLOR_BOULDER;
var UI_COLOR_MEDIUM_GRAY = "#888888";
exports.UI_COLOR_MEDIUM_GRAY = UI_COLOR_MEDIUM_GRAY;
var UI_COLOR_BRAND_GRAY = "#828387";
exports.UI_COLOR_BRAND_GRAY = UI_COLOR_BRAND_GRAY;
var UI_COLOR_STATUS_PENDING = "#8c8b8c";
exports.UI_COLOR_STATUS_PENDING = UI_COLOR_STATUS_PENDING;
var UI_COLOR_SANTAS_GRAY = "#979daa";
exports.UI_COLOR_SANTAS_GRAY = UI_COLOR_SANTAS_GRAY;
var UI_COLOR_NOBEL = "#b7b7b7";
exports.UI_COLOR_NOBEL = UI_COLOR_NOBEL;
var UI_COLOR_PLAIN_GRAY = "#cccccc";
exports.UI_COLOR_PLAIN_GRAY = UI_COLOR_PLAIN_GRAY;
var UI_COLOR_BORDER = "#d1d4e4";
exports.UI_COLOR_BORDER = UI_COLOR_BORDER;
var UI_COLOR_GRAY_WHITE = "#e6e6e6"; // rare

exports.UI_COLOR_GRAY_WHITE = UI_COLOR_GRAY_WHITE;
var UI_COLOR_GALLERY = "#eeeeee";
exports.UI_COLOR_GALLERY = UI_COLOR_GALLERY;
var UI_COLOR_ATHENS_GRAY = "#f1f2f6";
exports.UI_COLOR_ATHENS_GRAY = UI_COLOR_ATHENS_GRAY;
var UI_COLOR_LIGHT_GRAY = "#f1f2f7";
exports.UI_COLOR_LIGHT_GRAY = UI_COLOR_LIGHT_GRAY;
var UI_COLOR_ALABASTER = "#f7f7f7"; // very rare

exports.UI_COLOR_ALABASTER = UI_COLOR_ALABASTER;
var UI_COLOR_PALE_GRAY = "#f9f9fb";
exports.UI_COLOR_PALE_GRAY = UI_COLOR_PALE_GRAY;
var UI_COLOR_DARK_WHITE = "#f9fafc"; // rare

exports.UI_COLOR_DARK_WHITE = UI_COLOR_DARK_WHITE;
var UI_COLOR_OFF_WHITE = "#fcfcfe"; // very rare

exports.UI_COLOR_OFF_WHITE = UI_COLOR_OFF_WHITE;
var UI_COLOR_WHITE = "#ffffff";
exports.UI_COLOR_WHITE = UI_COLOR_WHITE;
var UI_COLOR_OFF_GREEN = "#567225"; // rare

exports.UI_COLOR_OFF_GREEN = UI_COLOR_OFF_GREEN;
var UI_COLOR_OFF_GREEN_LIGHTER = "#769147"; // rare

exports.UI_COLOR_OFF_GREEN_LIGHTER = UI_COLOR_OFF_GREEN_LIGHTER;
var UI_COLOR_GREEN = "#3c763d";
exports.UI_COLOR_GREEN = UI_COLOR_GREEN;
var UI_COLOR_ON_TRACK = "#57a92b";
exports.UI_COLOR_ON_TRACK = UI_COLOR_ON_TRACK;
var UI_COLOR_APPLE_GREEN = "#4CC417";
exports.UI_COLOR_APPLE_GREEN = UI_COLOR_APPLE_GREEN;
var UI_COLOR_BRIGHT_APPLE_GREEN = "#00E676"; // very rare

exports.UI_COLOR_BRIGHT_APPLE_GREEN = UI_COLOR_BRIGHT_APPLE_GREEN;
var UI_COLOR_LIGHT_GREEN = "#8bc63c"; // very rare

exports.UI_COLOR_LIGHT_GREEN = UI_COLOR_LIGHT_GREEN;
var UI_COLOR_BRAND_GREEN = "#a2ce5d";
exports.UI_COLOR_BRAND_GREEN = UI_COLOR_BRAND_GREEN;
var UI_COLOR_COLUMN = "#9bd067"; // rare

exports.UI_COLOR_COLUMN = UI_COLOR_COLUMN;
var UI_COLOR_CONDITION = "#e2ebd4";
exports.UI_COLOR_CONDITION = UI_COLOR_CONDITION;
var UI_COLOR_FORMULA = "#99ffd6";
exports.UI_COLOR_FORMULA = UI_COLOR_FORMULA;
var UI_COLOR_POTTERS_CLAY = "#967132"; // very rare

exports.UI_COLOR_POTTERS_CLAY = UI_COLOR_POTTERS_CLAY;
var UI_COLOR_OVERDUE = "#ff8a21";
exports.UI_COLOR_OVERDUE = UI_COLOR_OVERDUE;
var UI_COLOR_ORANGE = "#ffa500";
exports.UI_COLOR_ORANGE = UI_COLOR_ORANGE;
var UI_COLOR_YELLOW = "#fbb41e";
exports.UI_COLOR_YELLOW = UI_COLOR_YELLOW;
var UI_COLOR_MINOR_DISRUPTION = "#ffd700";
exports.UI_COLOR_MINOR_DISRUPTION = UI_COLOR_MINOR_DISRUPTION;
var UI_COLOR_NEW_TIME = "#ffbb80"; // very rare

exports.UI_COLOR_NEW_TIME = UI_COLOR_NEW_TIME;
var UI_COLOR_DURATION = "#ffcc80"; // very rare

exports.UI_COLOR_DURATION = UI_COLOR_DURATION;
var UI_COLOR_PICKLIST = "#ffdf80"; // very rare

exports.UI_COLOR_PICKLIST = UI_COLOR_PICKLIST;
var UI_COLOR_BANANA_MANIA = "#fbe1b1"; // very rare

exports.UI_COLOR_BANANA_MANIA = UI_COLOR_BANANA_MANIA;
var UI_COLOR_DATETIME = "#ffee80"; // very rare

exports.UI_COLOR_DATETIME = UI_COLOR_DATETIME;
var UI_COLOR_DATE = "#ffff80"; // very rare

exports.UI_COLOR_DATE = UI_COLOR_DATE;
var UI_COLOR_VANILLA = "#ffffe3"; // very rare

exports.UI_COLOR_VANILLA = UI_COLOR_VANILLA;
var UI_COLOR_PURPLE_BLUE = "#7f00ff";
exports.UI_COLOR_PURPLE_BLUE = UI_COLOR_PURPLE_BLUE;
var UI_COLOR_STUDIO = "#7946a0"; // very rare

exports.UI_COLOR_STUDIO = UI_COLOR_STUDIO;
var UI_COLOR_UPCOMING = "#8b65a1";
exports.UI_COLOR_UPCOMING = UI_COLOR_UPCOMING;
var UI_COLOR_NUMBER = "#d0a9f7";
exports.UI_COLOR_NUMBER = UI_COLOR_NUMBER;
var UI_COLOR_RED = "#cc181e";
exports.UI_COLOR_RED = UI_COLOR_RED;
var UI_COLOR_MAJOR_DISRUPTION = "#e30022";
exports.UI_COLOR_MAJOR_DISRUPTION = UI_COLOR_MAJOR_DISRUPTION;
var UI_COLOR_BURGUNDY = "#dd2c00";
exports.UI_COLOR_BURGUNDY = UI_COLOR_BURGUNDY;
var UI_COLOR_ROSE = "#d9534f";
exports.UI_COLOR_ROSE = UI_COLOR_ROSE;
var UI_COLOR_LIGHT_RED = "#fe7e73";
exports.UI_COLOR_LIGHT_RED = UI_COLOR_LIGHT_RED;
var UI_COLOR_BOOL = "#ff99bb"; // very rare

exports.UI_COLOR_BOOL = UI_COLOR_BOOL;
var UI_COLOR_ROSE_FOG = "#ecc8c5"; // very rare

exports.UI_COLOR_ROSE_FOG = UI_COLOR_ROSE_FOG;
var UI_COLOR_TRANSPARENT = "transparent"; // transparent

exports.UI_COLOR_TRANSPARENT = UI_COLOR_TRANSPARENT;